import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, ListChecks } from "lucide-react";
import { TrackerForm, TrackerList, TrackerInputRow } from "@/components/trackers/TrackerParts";

const EMPTY_FORM = { name: "", type: "scale", unit: "" };

export function TrackerManager({ trackers, onCreate, onArchive, subtitle, addLabel = "Add tracker" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [presets, setPresets] = useState([]);

  useEffect(() => {
    api.get("/trackers/presets").then((r) => setPresets(r.data.presets));
  }, []);

  const activeNames = new Set(trackers.map((t) => t.name.toLowerCase()));
  const quick = presets.filter((p) => !activeNames.has(p.name.toLowerCase()));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    await onCreate(form);
    setForm(EMPTY_FORM);
    setOpen(false);
  };

  return (
    <div className="warm-card p-6" data-testid="tracker-manager">
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2">
          <ListChecks className="w-5 h-5 text-amber-700" />
          <h3 className="font-display text-lg font-bold text-stone-900">Custom trackers</h3>
        </div>
        <button type="button" data-testid="tracker-add-toggle" onClick={() => setOpen((o) => !o)}
          className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full bg-stone-900 text-white hover:bg-amber-700">
          <Plus className="w-3.5 h-3.5" /> {addLabel}
        </button>
      </div>
      {subtitle && <p className="text-xs text-stone-500 mb-3">{subtitle}</p>}
      {open && <TrackerForm form={form} onChange={(patch) => setForm((f) => ({ ...f, ...patch }))} presets={quick} onPick={onCreate} onSubmit={submit} />}
      <TrackerList trackers={trackers} onArchive={onArchive} />
    </div>
  );
}

export function TrackerInputs({ trackers, values, onChange }) {
  if (!trackers.length) return null;
  const set = (id, v) => onChange(id, values[id] === v ? undefined : v);
  return (
    <div data-testid="tracker-inputs">
      <div className="text-xs font-semibold text-stone-600 mb-1.5">Your trackers (optional — leave blank to skip)</div>
      <div className="space-y-2.5">
        {trackers.map((t) => <TrackerInputRow key={t.id} t={t} value={values[t.id]} onSet={set} onChange={onChange} />)}
      </div>
    </div>
  );
}
